import React from 'react';
import { IconArrowRight } from '@tabler/icons-react';
export function HeroSection() {
  return <section className="relative py-24 md:py-32 px-5 w-full overflow-hidden min-h-[600px] md:min-h-[700px] pt-[80px] pb-[120px]" style={{
    background: '#002ca5'
  }} data-id="element-74">
      {/* Diagonal bottom edge */}
      <div className="absolute bottom-0 left-0 w-full pointer-events-none" style={{
      lineHeight: 0
    }} data-id="element-75">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="w-full h-[35px] md:h-[50px] block" xmlns="http://www.w3.org/2000/svg" data-id="element-76">
          <polygon points="0,80 1440,80 1440,30" fill="#FFFFFF" data-id="element-77" />
        </svg>
      </div>
      {/* Pink glow — top right */}
      <div className="absolute pointer-events-none" style={{
      width: '400px',
      height: '400px',
      top: '-80px',
      right: '-80px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(255,64,129,0.06) 0%, transparent 70%)'
    }} data-id="element-78" />

      <div className="max-w-6xl mx-auto relative" data-id="element-79">
        {/* Left — Text */}
        <div className="md:max-w-[55%] flex flex-col items-start justify-center relative z-10 pr-[10px]" data-id="element-80">
          {/* Eyebrow */}
          <p className="font-body text-sm uppercase tracking-widest text-white/70 mb-4" data-id="element-81">
            Un nuovo modo di gestire i tuoi B&amp;B
          </p>

          <h1 className="font-heading md:text-[3.1em] text-white font-[600] text-[40px]" style={{
          lineHeight: 1.1
        }} data-id="element-82">
            Il primo servizio di
            <br data-id="element-83" />
            pulizie e manutenzione
            <br data-id="element-84" />
            per B&amp;B{' '}
            <span className="relative inline-block" style={{
            color: '#FF4081'
          }} data-id="element-85">
              in Sharing.
              <svg className="absolute left-0 w-full pt-[4px] mt-[10px]" style={{
              bottom: '-4px',
              height: '12px'
            }} viewBox="0 0 200 12" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" data-id="element-86">
                <path d="M2 9 Q100 2 198 8" stroke="#FF4081" strokeWidth="3.5" strokeLinecap="round" fill="none" opacity="0.7" data-id="element-87" />
              </svg>
            </span>
          </h1>

          <p className="font-body text-lg md:text-xl mt-6 max-w-2xl leading-relaxed" style={{
          color: 'rgba(255,255,255,0.8)'
        }} data-id="element-88">
            Non è un marketplace. CleanAI aggrega le richieste degli host nella
            stessa zona, costruisce percorsi ottimizzati e abbatte il costo per
            tutti — senza abbassare la qualità.
          </p>

          <button onClick={() => document.getElementById('waitlist-form')?.scrollIntoView({
          behavior: 'smooth'
        })} className="mt-8 rounded-full px-8 py-3.5 uppercase tracking-wide hover:opacity-90 transition-opacity text-[14px] font-[500]" style={{
          backgroundColor: '#69ddff',
          color: '#000b29'
        }} data-id="element-89">
            Entra nella waitlist
            <IconArrowRight size={16} stroke={2} className="inline ml-1.5" data-id="element-90" />
          </button>
        </div>

        {/* Right — Large image overflowing right (desktop) */}
        <div className="mt-10 md:mt-0 md:absolute md:top-1/2 md:-translate-y-1/2 flex items-center justify-center" style={{
        right: '-18vw'
      }} data-id="element-91">
          <img src="https://cdn.magicpatterns.com/uploads/wvVXHfi8vPqc5d23Xp9GLr/Screenshot_2026-03-21_alle_17.18.04.png" alt="CleanAI app dashboard — opportunità sharing, pianificazione condivisa e interventi di manutenzione" className="w-full h-auto object-contain md:w-[700px] lg:w-[800px] xl:w-[900px] rounded-[4px] pl-0 md:pl-[140px] ml-[0px]" data-id="element-92" />
        </div>
      </div>
    </section>;
}